<!-- 
  WORKAROUND COMPONENT TEMPLATE

  This component includes instances of Ionic components with specific attributes 
  (like color="success" or checked="true") that are dynamically applied elsewhere 
  in the application. 

  Including these static instances prevents the Angular build optimizer 
  (specifically CSS tree-shaking/minification in Angular 19+ with the application builder) 
  from incorrectly removing the necessary CSS classes needed for the dynamic versions.

  See related discussion: https://github.com/ionic-team/ionic-framework/issues/30100
-->

<!-- ion-badge: Ensure dynamically applied color classes are preserved -->
<ion-badge color="success">Optimizer Fix</ion-badge>
<ion-badge color="warning">Optimizer Fix</ion-badge>
<ion-badge color="danger">Optimizer Fix</ion-badge>
<ion-badge color="medium">Optimizer Fix</ion-badge>
<!-- Add other colors used dynamically in your app if needed -->

<!-- ion-toggle: Ensure dynamically applied checked styles are preserved -->
<ion-toggle [checked]="true" aria-hidden="true">Optimizer Fix</ion-toggle>
